export default "__VITE_ASSET__DDioYYRR__"